<template>
    <section>
        <perfect-scrollbar>
            <table>
                <thead>
                    <tr>
                        <th class="action-column"></th>
                        <th>เลขที่เคลม</th>
                        <th>ข้อมูลผู้มาเคลม</th>
                        <th class="text-center">สถานะ</th>
                        <th>วันที่เปิดใบเคลม</th>
                        <th class="text-center">เคลมไปแล้ว</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in resultList" :key="index">
                        <td><div class="text-center"><router-link :to="'/job/claim?o=' + item.number" class="btn btn-sm btn-blue text-nowrap">ดูใบงาน</router-link></div></td>
                        <td>{{ item.number }}</td>
                        <td>
                            <span><b-icon icon="person" class="icon"></b-icon> {{ item.customer }}</span>
                        </td>
                        <td class="text-center"><div class="status" :class="item.status.style">{{ item.status.text }}</div></td>
                        <td class="date-time"><b-icon icon="clock"></b-icon> {{ item.openDate }}</td>
                        <td class="text-center">{{ item.claimDateCount }}</td>
                    </tr>
                </tbody>
            </table>
        </perfect-scrollbar>

        <div class="no-data" v-if="resultList.length === 0">
            <b-icon icon="exclamation-diamond"></b-icon>
            <span>ไม่มีประวัติรายการใบเคลม</span>
        </div>

        <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="resultList.length" class="mt-4"></paging>
    </section>
</template>

<script>
import MixinJobTable from '@/components/job/JobTable';

export default {
    mixins: [ MixinJobTable ],
    data() {
        return {
            activePage: 1,
            pageSize: 20,
            resultList: []
        }
    },
    props: {
        jobList: Array
    },
    mounted() {
        this.renderJobList();
    },
    methods: {
        renderJobList() {
            this.resultList = this.mapViewData(this.jobList.filter(x => x.jobType === this.$Constants.JOB_FORM_CLAIM));
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    number: item.number,
                    customer: [ item.customer.claimFirstName, item.customer.claimLastName ].join(' '),
                    status: this.mixinsJobTable_GetClaimStatusDisplay(item.status),
                    openDate: this.$AppUtility.displayTimeFormat(item.openDate),
                    claimDateCount: item.status !== this.$Constants.JOB_STATUS_COMPLETE ? this.mixinsJobTable_GetDifferenceDay(item.openDate) + ' วัน' : '-'
                });
            });

            return data;
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/job/JobList.scss';
</style>